
export default {
  name: 'TenlifeButton',

  props: {
    data: {
      type: Object,
      default: () => ({
        text: '[This is the Text]',
        link: '',
        icon: 'arrow',
        textColor: 'black',
        buttonColor: 'red',
        buttonBorderColor: 'black',
        target: '_self',
        disabled: false
      }),
    },
  },

  data() {
    return {
      text: this.data.text,
      link: this.data.link,
      icon: this.data.icon,
      buttonColor: this.data.buttonColor,
      buttonBorderColor: this.data.buttonBorderColor,
      target: this.data.target,
      disabled: this.data.disabled,
    }
  },
  
  computed: {
    styles() {
      const styles = []
      if (this.data?.buttonColor) {
        styles.push(
          {
            background: `${this.data?.buttonColor}`
          }
        ) 
      }
      if (this.data?.buttonBorderColor) {
        styles.push({
          'border-color': `${this.data?.buttonBorderColor}`,
        })
      }
      return styles;
    },
    buttonStyles() {
      const styles = []
      if (this.data?.textColor) {
        if(this.data?.textColor === 'green'){
          styles.push(
            {
              color: `#00D3BE`
            }
          ) 
        } else {
          styles.push(
            {
              color: `${this.data?.textColor}`
            }
          ) 
        }
      }
      return styles;
    }
  }

}
